import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { EnvironmentService } from './environment.service';
import { switchMap } from 'rxjs';
/**
 * The Service for the Eventssorting
 */
@Injectable({
  providedIn: 'root'
})
export class EventSortingService {
  /**
   * The constructor for the EventSortingService
   * @param http 
   * @param environment 
   */
  constructor(
    private http: HttpClient,
    private environment: EnvironmentService
  ) {

  }
  /**
   * Get the Events sorted
   * @returns 
   */
  getSortedEvents() {
    return this.environment.apiV1$.pipe(
      switchMap(url => this.http.get(`${url}/event/sorting`)
      )
    )
  }
  /**
   * Set the Events sorted
   * @returns 
   */
  setSortedEvents(events: Array<any>) {
    return this.environment.apiV1$.pipe(
      switchMap(url => this.http.put(`${url}/event/sorting`, events)
      )
    )
  }
}
